module.exports = __webpack_public_path__ + "static/media/createuser.2d82d0b1.svg";